import React from 'react'
import styles from './Button.module.css'

type ButtonVariant = 'primary' | 'secondary' | 'destructive' | 'icon' | 'icon-primary' | 'text'

interface ButtonProps {
    children?: React.ReactNode
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
    variant?: ButtonVariant
    disabled?: boolean
    type?: 'button' | 'submit' | 'reset'
    form?: string
    fullWidth?: boolean
    inline?: boolean
    className?: string
    ariaLabel?: string
}

const variantClass: Record<ButtonVariant, string> = {
    primary: styles.primary,
    secondary: styles.secondary,
    destructive: styles.destructive,
    icon: styles.icon,
    'icon-primary': styles.iconPrimary,
    text: styles.text,
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(function Button(
    { children, onClick, variant = 'primary', disabled, type = 'button', form, fullWidth, inline, className, ariaLabel },
    ref
) {
    return (
        <button
            ref={ref}
            type={type}
            form={form}
            onClick={onClick}
            disabled={disabled}
            aria-label={ariaLabel}
            className={[
                styles.button,
                variantClass[variant],
                fullWidth ? styles.fullWidth : '',
                inline ? styles.inline : '',
                className || '',
            ].filter(Boolean).join(' ')}
        >
            {children}
        </button>
    )
})

export default Button
